import React, { useContext, useEffect, useState } from "react";
import { Drawer, Button, Row, Col, Select, Typography, Input, Modal } from "antd";

import { MassiveEmitionContext } from "../../../contexts";
import { dte, getDefaultFrases, ivaRegimenExento, taxesByDte } from "../../../services";
import MassiveEmitionTable from "./components/MassiveEmitionTable";
import PropTypes from "prop-types";

const { Title } = Typography;
const { TextArea } = Input;

const MassiveEmitionDrawer = ({token, company, clients}) => {
	const { 
		toggleDrawerMassiveEmition,
		modifyInvoice,
		isIncomplete,
		isDrawerOpen,
		emitMassive, 
		invoice,
		isLoading,
		openEmailConfiguration, 
		setOpenEmailConfiguration
	} = useContext(MassiveEmitionContext);
	const [taxOptions, setTaxOptions] = useState([]);

	const defaulMessage = `<p>Estimado <b>{CLIENT_NAME}</b>,</p>
<p>Adjunto encontrarán su factura. Agradecemos que realice el pago y nos envíe el comprobante respondiendo a este correo.</p>
<p>Si tiene alguna consulta o necesita más información, no dude en contactarnos. Estamos a su disposición para cualquier aclaración.</p>
<p>Atentamente,</p><p><b>{COMPANY_NAME}</b></p>`;

	useEffect(() => {
		if (!invoice.invoice_type) return;

		const dteType = invoice.invoice_type;

		let baseTaxes = ivaRegimenExento.includes(company.tax_authority_specifications.iva_regimen) ? ["IVA EXENTO"] : ["IVA"];
		const dteTaxes = Object.keys(taxesByDte[dteType] || {});

		if (!dteTaxes.includes(baseTaxes[0])){
			baseTaxes = [];
		}
        
		const updatedTaxOptions = dteTaxes.map(taxKey => {
			let finalTax = { label: taxKey, value: taxKey };
			if (taxKey === "IVA" || taxKey === "IVA EXENTO") {
				finalTax.disabled = true;
			}
			return finalTax;
		});

		setTaxOptions([...updatedTaxOptions, ...baseTaxes.map(tax => ({ label: tax, value: tax, disabled: true }))]);

		modifyInvoice("taxes", baseTaxes);

		modifyInvoice("frases", getDefaultFrases(company.tax_authority_specifications, dteType));
	}, [invoice.invoice_type]);


	const titleConf = { margin: "0", padding: "0", width:"100%", textAlign:"center" };

	return (
		<>
			<Drawer
				title="Emisión masiva de facturas"
				placement="right"
				width="100%"
				onClose={toggleDrawerMassiveEmition}
				open={isDrawerOpen}
			>
				<Row gutter={[10, 10]}>
					<Col span={8}>
						<Row gutter={[10, 10]}>
							<Col span={24}>
								<Title level={5} style={titleConf}>Tipo de DTE</Title>
								<Select
									showSearch
									style={{ 
										width: "100%"
									}}
									placeholder="Selecciona un tipo de DTE"
									optionFilterProp="label"
									onChange={modifyInvoice.bind(this, "invoice_type")}
									filterOption={(input, option) =>
										(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
									}
									value={invoice.invoice_type}
									options={ 
										company.tax_authority_specifications.iva_regimen?
											dte[company.tax_authority_specifications.iva_regimen] : 
											[]
									}
								/>
							</Col>
							<Col span={14}>
								<Title level={5} style={titleConf}>Establecimiento</Title>
								<Select
									showSearch
									style={{ 
										width: "100%"
									}}
									placeholder="Selecciona un establecimiento"
									optionFilterProp="label"
									onChange={modifyInvoice.bind(this, "establishment_id")}
									filterOption={(input, option) =>
										(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
									}
									value={invoice.establishment_id}
									options={company.tax_authority_specifications.establishments?.map(establishment => ({
										value: establishment.id,
										label: establishment.name,
									}))}
								/>
							</Col>
							<Col span={10}>
								<Title level={5} style={titleConf}>Moneda</Title>
								<Select
									showSearch
									style={{ width: "100%" }}
									placeholder="Selecciona una Moneda"
									optionFilterProp="label"
									onChange={modifyInvoice.bind(this, "currency")}
									filterOption={(input, option) =>
										(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
									}
									value={invoice.currency}
									options={
										[
											{
												value: "GTQ",
												label: "GTQ - Quetzales"
											},
											{
												value: "USD",
												label: "USD - Dólares"
											}
										]
									}
								/>
							</Col>
						</Row>
					</Col>
					<Col span={16}>
						<Row gutter={[10, 10]}>
							<Col span={5}>
								<Title level={5} style={titleConf}>Tipo de ítem</Title>
								<Select
									showSearch
									style={{ 
										width: "100%"
									}}
									placeholder="Selecciona un tipo de ítem"
									optionFilterProp="label"
									onChange={modifyInvoice.bind(this, "item_type")}
									filterOption={(input, option) =>
										(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
									}
									value={invoice.item_type}
									options={
										[
											{
												value: "B",
												label: "Bienes"
											},
											{
												value: "S",
												label: "Servicios"
											}
										]
									}
								/>
							</Col>
							<Col span={10}>
								<Title level={5} style={titleConf}>Impuestos</Title>
								<Select
									showSearch
									style={{ 
										width: "100%"
									}}
									mode="tags"
									placeholder="Selecciona un Impuesto"
									optionFilterProp="label"
									onChange={modifyInvoice.bind(this, "taxes")}
									filterOption={(input, option) =>
										(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
									}
									value={invoice.taxes}
									options={taxOptions}
								/>
							</Col>
							<Col span={9}>
								<Title level={5} style={titleConf}>Cuenta Contable</Title>
								<Select
									showSearch
									style={{ 
										width: "100%"
									}}
									placeholder="Selecciona un tipo de ítem"
									optionFilterProp="label"
									onChange={modifyInvoice.bind(this, "accounting_account")}
									filterOption={(input, option) =>
										(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
									}
									value={invoice.accounting_account}
									options={
										company.accounting_resources.accounting_plan && company.accounting_resources.sale_accounts
											? company.accounting_resources.accounting_plan
												.filter((element) =>
													company.accounting_resources.sale_accounts.includes(
														element.id
													)
												)
												.map((element) => ({
													label: element.display_name,
													value: String(element.id),
												}))
											: []}
								/>
							</Col>
							<Col span={4}>
								<Title level={5} style={{ margin: "0", padding: "0", width:"100%", textAlign:"right" }}>Descripción</Title>
							</Col>
							<Col span={20}>
								<TextArea 
									size="small" 
									rows={3} 
									placeholder="Descripción"
									value={invoice.item_description}
									onChange={(e) => modifyInvoice("item_description", e.target.value)}
								/>
							</Col>
						</Row>
					</Col>
					<Col span={24}>
						<MassiveEmitionTable 
							company={company}
							clients={clients} 
							invoice={invoice}
							modifyInvoice={modifyInvoice}
						/>
					</Col>
					<Col span={24}>
						<Button 
							type="primary"
							block
							style={{
								width: "100%",
								height: "80px",
								fontSize: "40px",
								fontWeight: "bold",
							}}
							onClick={setOpenEmailConfiguration.bind(this, true)}
							disabled={isIncomplete}
						>Continuar</Button>
					</Col>
				</Row>
			</Drawer>
			<Modal
				open={openEmailConfiguration}
				width={"80vw"}
				okText="Emitir"
				onOk={() => emitMassive(token, company)}
				onCancel={isLoading ? null : setOpenEmailConfiguration.bind(this, false)}
				closable={!isLoading}
				confirmLoading={isLoading}
			>
				<Button
					style={{
						margin: "10px",
						marginLeft: "0",
					}}
					onClick={() => modifyInvoice("email_message", invoice.email_message + " {COMPANY_NAME}")}
				>Nombre Compañía</Button>
				<Button
					style={{
						margin: "10px",
						marginLeft: "0",
					}}
					onClick={() => modifyInvoice("email_message", invoice.email_message + " {CLIENT_NAME}")}
				>Nombre Cliente</Button>
				<TextArea 
					rows={8} 
					placeholder="Mensaje"
					value={invoice.email_message}
					onChange={(e) => modifyInvoice("email_message", e.target.value)}
				/>
				<Button
					style={{
						margin: "10px",
						marginLeft: "0",
					}}
					onClick={() => modifyInvoice("email_message", defaulMessage)}
				>
                    Mensaje por Defecto
				</Button>
			</Modal>
		</>
	);
};

MassiveEmitionDrawer.propTypes = {
	token: PropTypes.string.isRequired, 
	company: PropTypes.object.isRequired,
	clients: PropTypes.array.isRequired,
};

export default MassiveEmitionDrawer;